/* VAGO — hover a colour dot on a product card to preview that colour's image */
(function () {
  function init(root) {
    (root || document).querySelectorAll('.card__swatch-link[data-swatch-image]').forEach(function (link) {
      if (link.dataset.vagoBound) return;
      link.dataset.vagoBound = '1';
      var card = link.closest('.card-wrapper');
      if (!card) return;
      var img = card.querySelector('.card__media .media img');
      if (!img) return;
      var original = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
      var restore = function () {
        if (!card.dataset.vagoLocked) {
          img.setAttribute('src', original.src);
          if (original.srcset) img.setAttribute('srcset', original.srcset);
        }
      };
      var swap = function () {
        img.setAttribute('src', link.dataset.swatchImage);
        img.removeAttribute('srcset');
      };
      link.addEventListener('mouseenter', swap);
      link.addEventListener('focus', swap);
      link.addEventListener('mouseleave', restore);
      link.addEventListener('blur', restore);
    });
  }
  init();
  // Re-bind after filter / pagination AJAX updates
  var target = document.getElementById('ProductGridContainer');
  if (target && 'MutationObserver' in window) {
    new MutationObserver(function () { init(target); }).observe(target, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* PDP: hovering a linked-colour swatch previews its name in the label */
(function () {
  document.querySelectorAll('.product-variations').forEach(function (wrap) {
    var current = wrap.querySelector('.product-variations__current');
    if (!current) return;
    wrap.querySelectorAll('.product-variations__link[data-label]').forEach(function (link) {
      link.addEventListener('mouseenter', function () { current.textContent = link.dataset.label; });
      link.addEventListener('mouseleave', function () { current.textContent = current.dataset.default; });
    });
  });
})();
